<template>
  <div class="my-home">
    <Sidebar
      :activeTab="activeTab"
      @update:activeTab="onTabChange"
    />
    <section class="content">
      <!-- 這裡由路由控制顯示哪個頁面 -->
      <router-view />
    </section>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import Sidebar from './component/sidebar.vue'
import { computed } from 'vue'

const route = useRoute()
const router = useRouter()

// 当前激活的标签来自路径名
const activeTab = computed(() => route.name || 'HomePage')


// 当点击 sidebar 项目时切换路由
function onTabChange(tab) {
  router.push({ name: tab })
}
</script>

<style scoped>
.my-home {
  display: flex;
}
.content {
  flex: 1;
  padding: 20px;
  transition: margin-left 0.3s;
}
</style>